import {Box, Container} from '@mui/material'
import {Typography} from '@mui/material'
import {AppContext} from './Context'

import {useContext, useEffect} from 'react'
import {NavBar} from './Header'

function Header() {
	const {setShareYourInterests, setSearchOpportunities} =
		useContext(AppContext)
	const showDowntime = process.env.REACT_APP_DOWNTIME

	const handleSearchClick = () => {
		setShareYourInterests(true)
		setSearchOpportunities(true)
	}
	useEffect(() => {
		handleSearchClick()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<NavBar />
			{!showDowntime && (
				<Container
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						paddingY: 4,
					}}
					maxWidth="lg"
				>
					<Box
						sx={{
							backgroundColor: '#f5f5f5',
							padding: '30px',
							borderRadius: '12px',
							boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
							maxWidth: {xs: '100%', md: '75%'},
							textAlign: 'center',
						}}
					>
						<Typography
							variant="h5"
							sx={{
								fontWeight: 'bold',
								color: '#089eb6',
								marginBottom: '12px',
							}}
						>
							Error : Invalid Link
						</Typography>

						<Box
							component="ol"
							sx={{
								listStyleType: 'upper-alpha',
								color: 'red',
								textAlign: 'left',
								paddingLeft: '20px',
								fontSize: '1rem',
								lineHeight: '20px',
								'& li': {
									marginBottom: '8px',
								},
							}}
						>
							Looks like you have incorrect link for the
							internship portal. Please refer to the link received
							in email.
						</Box>
					</Box>
				</Container>
			)}
		</>
	)
}
export default Header
